module.exports = __webpack_public_path__ + "static/media/theEmpire.f7dc45bf.jpeg";